import { useTheme } from "@mui/system";

export default function RecommendationsIcon({size = 40}) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 56;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg 
      width={baseWidth}
      height={height} 
      viewBox="0 0 40 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
    <path 
        d="M15.2941 52.5C15.2941 54.433 16.8743 56 18.8235 56H21.1764C23.1257 56 24.7059 54.433 24.7059 52.5V51.3333H15.2941V52.5ZM20 0C8.95433 0 0 8.8797 0 19.8333C0 25.8486 2.70048 31.2385 6.9647 34.8758C9.58002 37.1065 15.2941 48.9999 15.2941 48.9999H24.7059C24.7059 48.9999 30.4235 37.0883 32.9827 34.9204C37.2774 31.2827 40 25.8734 40 19.8333C40.0001 8.87976 31.0457 0 20 0ZM31.4553 33.0966C29.1972 35.0063 24.1523 46.6667 24.1523 46.6667H21.1765V31.9719L26.7217 26.473C27.1779 26.0204 27.1779 25.2868 26.7217 24.8344C26.2654 24.382 25.5256 24.382 25.0693 24.8344L20.0057 29.8558L13.143 23.0503C12.6835 22.5946 11.9387 22.5946 11.4793 23.0503C11.0197 23.5059 11.0197 24.2445 11.4793 24.7002L18.6216 31.783C18.684 31.8449 18.752 31.8977 18.8235 31.9427V46.6667H15.8477C15.8477 46.6667 10.8058 35.0224 8.49828 33.0573C4.73559 29.853 2.35288 25.1049 2.35288 19.8056C2.35288 10.156 10.2537 2.3334 19.9999 2.3334C29.7462 2.3334 37.647 10.156 37.647 19.8056C37.6471 25.1265 35.2448 29.892 31.4553 33.0966Z" 
        fill={theme.palette.rgd.primary}
    />
    </svg>
  )
}